<template>
  <label class="nc-checkbox" :class="{ 'nc-checkbox--disabled': disabled }" @click.prevent="toggle">
    <span class="nc-checkbox__box" :class="{ 'nc-checkbox__box--checked': modelValue }">
      <mdicon v-if="modelValue" name="check" size="14" />
    </span>
    <span v-if="label || $slots.default" class="nc-checkbox__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'NcCheckbox',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue);
      }
    },
  },
};
</script>

<style scoped>
.nc-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
/* Tikgebied minimaal 44px (iOS HIG / WCAG 2.5.5) zonder de layout te wijzigen. */
.nc-checkbox::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  min-width: 44px;
  min-height: 44px;
}
.nc-checkbox--disabled { opacity: 0.4; pointer-events: none; }
.nc-checkbox__box {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid var(--nc-border, #d0d5dd);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s ease;
  color: transparent;
  background: transparent;
}
.nc-checkbox__box--checked {
  background: var(--nc-color-primary, #14b69a);
  border-color: var(--nc-color-primary, #14b69a);
  color: white;
}
.nc-checkbox__label {
  font-size: var(--nc-font-size-sm, 14px);
  color: var(--nc-text, #1a1a2e);
}
</style>
